import React, { useState, useEffect } from 'react';
import styles from './BrandwiseAnalysis.module.css';
import FilterSection from './brandwise/FilterSection';
import FilterBadges from './brandwise/FilterBadges';
import QuarterlyTable from './brandwise/QuarterlyTable';
import { targetAnalyticsApi } from '../../../../api/targetAnalytics/targetAnalyticsApi';
import * as XLSX from 'xlsx';

const BrandwiseAnalysis = () => {
  const [selectedYear, setSelectedYear] = useState('FY 2025-26');
  const [selectedSalesPerson, setSelectedSalesPerson] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [data, setData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Hardcoded target margin values for categories (%)
  const targetMarginValues = {
    "3A Chemicals": 25,
    "BIKAI": 20,
    "CATO": 30,
    "FD Cell": 25,
    "KANTO": 25,
    "Capricorn": 20,
    "VOLAB": 20,
    "Density": 20,
    "Deutero": 25,
    "Trading": 15,
    "Life Science": 25,
    "Other": 20,
  };

  // Category mapping configuration
  const categoryMapping = {
    Items: "Trading",
    "3A Chemicals": "3A Chemicals",
    Catalyst: "Density",
    Solvent: "Density",
    Polymer: "Density",
    "Fine Chemicals": "Density",
    Reagent: "Density",
    "Biological Buffers": "Life Science",
    Intermediates: "Density",
    API: "CATO",
    "Stable Isotope reagents": "Deutero",
    "Building Blocks": "Density",
    Membranes: "Life Science",
    "Laboratory Containers & Storage": "FD Cell",
    Enzyme: "Life Science",
    Biochemicals: "Life Science",
    "Reference Materials": "KANTO",
    "Secondary Standards": "KANTO",
    Instruments: "BIKAI",
    Services: "NULL",
    "Analytical Standards": "KANTO",
    "Nucleosides and Nucleotides": "Life Science",
    Nitrosamine: "CATO",
    "Pesticide Standards": "CATO",
    Trading: "Trading",
    Carbohydrates: "Life Science",
    "USP Standards": "CATO",
    "EP Standards": "CATO",
    "Indian pharmacopoeia": "CATO",
    "British Pharmacopoeia": "CATO",
    Impurity: "CATO",
    "NMR Solvents": "Deutero",
    "Stable isotopes": "Deutero",
    Glucuronides: "CATO",
    Metabolites: "CATO",
    Capricorn: "Capricorn",
    "Analytical Instruments": "BIKAI",
    "Lab Consumables": "FD Cell",
    "Equipment and Instruments": "BIKAI",
    Ultrapur: "KANTO",
    Dyes: "Density",
    "New Life Biologics": "Life Science",
    "Food Grade": "Life Science",
    "Lab Systems & Fixtures": "BIKAI",
    Peptides: "Life Science",
    "Ultrapur-100": "KANTO",
    "Amino Acids": "Life Science",
    "Cell Culture": "Life Science",
    "Natural Products": "Life Science",
    "Multiple Pharmacopoeia": "CATO",
    "Metal Standard Solutions": "KANTO",
    "High Purity Acids": "KANTO",
    "HPLC consumables": "BIKAI",
    "HPLC configurations": "BIKAI",
    VOLAB: "VOLAB",
    "Life science": "Life Science",
    Kanto: "KANTO",
    "Meatls&materials": "Density",
  };

  // // Function to merge categories in frontend
  // const mergeCategories = (rawData) => {
  //   const mergedData = {};

  //   rawData.forEach((row) => {
  //     const key = `${row.year}-${row.monthNumber}`;

  //     if (!mergedData[key]) {
  //       mergedData[key] = {
  //         Year: row.year,
  //         Month: row.month,
  //         MonthNumber: row.monthNumber,
  //       };
  //     }

  //     // Process each category column in the row
  //     Object.keys(row).forEach((column) => {
  //       if (column.endsWith('_Sales') || column.endsWith('_Margin')) {
  //         const originalCategory = column.replace(/_Sales|_Margin/, '');
  //         const targetCategory = categoryMapping[originalCategory] || 'Other';

  //         // Skip NULL categories
  //         if (targetCategory === 'NULL') return;

  //         const salesKey = `${targetCategory}_Sales`;
  //         const marginKey = `${targetCategory}_Margin`;

  //         // Initialize if not exists
  //         if (!mergedData[key][salesKey]) {
  //           mergedData[key][salesKey] = 0;
  //           mergedData[key][marginKey] = 0;
  //         }

  //         if (column.endsWith('_Sales')) {
  //           // Add sales directly
  //           mergedData[key][salesKey] += row[column] || 0;
  //         } else if (column.endsWith('_Margin')) {
  //           // For margin, store temporary data for weighted calculation
  //           if (!mergedData[key]._tempMargins) {
  //             mergedData[key]._tempMargins = {};
  //           }
  //           if (!mergedData[key]._tempMargins[targetCategory]) {
  //             mergedData[key]._tempMargins[targetCategory] = {
  //               totalWeightedMargin: 0,
  //               totalSales: 0,
  //             };
  //           }
  //           const sales = row[`${originalCategory}_Sales`] || 0;
  //           const margin = row[column] || 0;
  //           mergedData[key]._tempMargins[targetCategory].totalWeightedMargin +=
  //             sales * (margin / 100);
  //           mergedData[key]._tempMargins[targetCategory].totalSales += sales;
  //         }
  //       }
  //     });
  //   });

  //   // Calculate final weighted margins
  //   Object.keys(mergedData).forEach((key) => {
  //     const row = mergedData[key];
  //     if (row._tempMargins) {
  //       Object.keys(row._tempMargins).forEach((category) => {
  //         const { totalWeightedMargin, totalSales } = row._tempMargins[category];
  //         const marginKey = `${category}_Margin`;
  //         const marginValue =
  //           totalSales > 0 ? (totalWeightedMargin / totalSales) * 100 : 0;
  //         row[marginKey] = Number(marginValue.toFixed(2));
  //       });
  //       // Remove temporary data
  //       delete row._tempMargins;
  //     }
  //   });

  //   return Object.values(mergedData);
  // };
  const mergeCategories = (rawData) => {
  const mergedData = {};

  rawData.forEach((row) => {
    const key = `${row.Year}-${row.MonthNumber}`;

    if (!mergedData[key]) {
      mergedData[key] = {
        Year: row.Year,
        Month: row.Month,
        MonthNumber: row.MonthNumber,
        _tempMargins: {},
      };
    }

    const originalCategory = row.Category;
    const targetCategory = categoryMapping[originalCategory] || 'Other';

    // Skip NULL categories
    if (targetCategory === 'NULL') return;

    const salesKey = `${targetCategory}_Sales`;
    const marginKey = `${targetCategory}_Margin`;

    // Initialize if not exists
    if (!mergedData[key][salesKey]) {
      mergedData[key][salesKey] = 0;
    }
    if (!mergedData[key]._tempMargins[targetCategory]) {
      mergedData[key]._tempMargins[targetCategory] = {
        totalWeightedMargin: 0,
        totalSales: 0,
      };
    }

    const sales = row.Sales || 0;
    const margin = row.Margin || row.GrossMargin || row.margin || 0; // adjust field name if needed

    // Accumulate sales
    mergedData[key][salesKey] += sales;

    // Accumulate weighted margin
    mergedData[key]._tempMargins[targetCategory].totalWeightedMargin += sales * (margin / 100);
    mergedData[key]._tempMargins[targetCategory].totalSales += sales;
  });

  // Calculate final weighted margins
  Object.values(mergedData).forEach((row) => {
    Object.keys(row._tempMargins).forEach((category) => {
      const { totalWeightedMargin, totalSales } = row._tempMargins[category];
      row[`${category}_Margin`] = totalSales > 0
        ? Number(((totalWeightedMargin / totalSales) * 100).toFixed(2))
        : 0;
    });
    delete row._tempMargins;
  });

  return Object.values(mergedData);
};

  // Auto-fetch data when filters change
  useEffect(() => {
    fetchData();
  }, [selectedYear, selectedSalesPerson, selectedRegion, selectedState]);

  const fetchData = async () => {
    setLoading(true);
    setError(null);

    try {
      const params = {
        year: selectedYear,
      };

      if (selectedSalesPerson && selectedSalesPerson !== '') {
        params.slpCode = selectedSalesPerson;
      }

      if (selectedRegion && selectedRegion !== '') {
        params.region = selectedRegion;
      }

      if (selectedState && selectedState !== '') {
        params.state = selectedState;
      }

      const result = await targetAnalyticsApi.getQuarterlyAnalysis(params);
      console.log('🔍 Full result:', result);
    console.log('🔍 result.data:', result?.data);
    console.log('🔍 Is array?', Array.isArray(result));
    console.log('🔍 Keys:', result ? Object.keys(result) : 'null/undefined');

      if (result.data) {
        // Merge categories in frontend
        const mergedData = mergeCategories(result.data);

        // Build category list
        const categorySet = new Set();

        // Add all possible categories from mapping
        Object.values(categoryMapping).forEach(cat => {
          if (cat !== 'NULL') {
            categorySet.add(cat);
          }
        });

        // Also add categories from actual data
        mergedData.forEach((r) => {
          Object.keys(r).forEach((k) => {
            if (k.endsWith('_Sales')) {
              const cat = k.replace('_Sales', '');
              if (cat !== '_tempMargins' && categoryMapping[cat] !== 'NULL') {
                categorySet.add(cat);
              }
            }
          });
        });

        // Filter out categories with 0 total sales
        const categoriesWithSales = [...categorySet].filter(category => {
          const totalSales = mergedData.reduce((sum, row) => {
            return sum + (row[`${category}_Sales`] || 0);
          }, 0);
          return totalSales > 0;
        });

        // Preferred ordering
        const preferredOrder = [
          '3A Chemicals', 'BIKAI', 'CATO', 'FD Cell', 'KANTO',
          'Capricorn', 'VOLAB', 'Density', 'Deutero', 'Trading',
          'Life Science', 'Other',
        ];

        const finalCategories = [
          ...preferredOrder.filter((c) => categoriesWithSales.includes(c)),
          ...categoriesWithSales.filter((c) => !preferredOrder.includes(c)),
        ];

        setCategories(finalCategories);
        setData(mergedData);
      } else {
        setCategories([]);
        setData([]);
      }
    } catch (err) {
      setError('Failed to load data');
      console.error(err);
      setCategories([]);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilters = () => {
    setSelectedYear('FY 2025-26');
    setSelectedSalesPerson('');
    setSelectedRegion('');
    setSelectedState('');
  };

  const handleDownloadExcel = () => {
    if (data.length === 0 || categories.length === 0) {
      alert('No data to export');
      return;
    }

    try {
      const exportData = [];

      // Header Row 1
      const headerRow1 = ['Year', 'Month', 'Total', '', '', ''];
      categories.forEach(cat => {
        headerRow1.push(cat, '', '', '');
      });

      // Header Row 2
      const headerRow2 = ['', '', 'Achieved %', 'Target (Cr)', 'Sales (Cr)', 'GM %'];
      categories.forEach(cat => {
        const targetMargin = targetMarginValues[cat] || 20;
        headerRow2.push('Achieved %', 'Target (Cr)', 'Sales (Cr)', `GM (${targetMargin}%)`);
      });

      exportData.push(headerRow1);
      exportData.push(headerRow2);

      // Data rows
      data.forEach(row => {
        const rowData = [row.Year, row.Month];

        let totalSales = 0;
        let totalWeightedMargin = 0;

        categories.forEach(cat => {
          const sales = row[`${cat}_Sales`] || 0;
          const margin = row[`${cat}_Margin`] || 0;
          totalSales += sales;
          totalWeightedMargin += sales * (margin / 100);
        });

        const avgMargin = totalSales > 0 ? (totalWeightedMargin / totalSales) * 100 : 0;

        // Add TOTAL columns
        rowData.push(
          '-', // Achieved % (simplified)
          0,   // Target (simplified)
          (totalSales / 10000000).toFixed(2),
          avgMargin.toFixed(2)
        );

        // Add category data
        categories.forEach(cat => {
          const sales = row[`${cat}_Sales`] || 0;
          const margin = row[`${cat}_Margin`] || 0;
          const salesCr = (sales / 10000000).toFixed(2);

          rowData.push(
            '-', // Achieved % (simplified)
            0,   // Target (simplified)
            salesCr,
            margin.toFixed(2)
          );
        });

        exportData.push(rowData);
      });

      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.aoa_to_sheet(exportData);
      XLSX.utils.book_append_sheet(wb, ws, 'Quarterly Analysis');
      XLSX.writeFile(
        wb,
        `Quarterly_Analysis_${selectedYear.replace(/ /g, '_')}_${new Date().toISOString().split('T')[0]}.xlsx`
      );
    } catch (err) {
      console.error('Error exporting to Excel:', err);
      alert('Failed to export data');
    }
  };

  return (
    <div className={styles.wrapper}>
      <FilterSection
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedSalesPerson={selectedSalesPerson}
        setSelectedSalesPerson={setSelectedSalesPerson}
        selectedRegion={selectedRegion}
        setSelectedRegion={setSelectedRegion}
        selectedState={selectedState}
        setSelectedState={setSelectedState}
        onReset={handleResetFilters}
      />

      <FilterBadges
        selectedYear={selectedYear}
        selectedSalesPerson={selectedSalesPerson}
        selectedRegion={selectedRegion}
        selectedState={selectedState}
      />

      {error && <div className={styles.errorMessage}>{error}</div>}

      {loading ? (
        <div className={styles.loadingContainer}>
          <div className={styles.loadingSpinner} />
          <div className={styles.loadingText}>Loading data...</div>
        </div>
      ) : data.length === 0 ? (
        <div className={styles.emptyState}>
          <div className={styles.emptyIcon}>📊</div>
          <h3 className={styles.emptyTitle}>No Data Available</h3>
          <p className={styles.emptyText}>
            Select filters to load quarterly performance data
          </p>
        </div>
      ) : (
        <QuarterlyTable
          data={data}
          categories={categories}
          onDownloadExcel={handleDownloadExcel}
          targetMargins={targetMarginValues}
        />
      )}
    </div>
  );
};

export default BrandwiseAnalysis;